module.exports = __webpack_public_path__ + "static/startingstyle1-60f799780a25288d007ac3a32034934c.mp4";